import { render, staticRenderFns } from "./InvalidRole.vue?vue&type=template&id=dedf518a&scoped=true&"
import script from "./InvalidRole.vue?vue&type=script&lang=ts&"
export * from "./InvalidRole.vue?vue&type=script&lang=ts&"
import style0 from "./InvalidRole.vue?vue&type=style&index=0&id=dedf518a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedf518a",
  null
  
)

export default component.exports